import { render, staticRenderFns } from "./labels-edit.vue?vue&type=template&id=206c7fde&"
import script from "./labels-edit.vue?vue&type=script&lang=js&"
export * from "./labels-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports